import { render, staticRenderFns } from "./ProposalRequestContract.vue?vue&type=template&id=59a6ea16&"
import script from "./ProposalRequestContract.vue?vue&type=script&lang=js&"
export * from "./ProposalRequestContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports